import { SVGProps } from 'react';
const SvgDragHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM6 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM18 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
    />
  </svg>
);
export default SvgDragHorizontal;
